import { PaginationInfo } from 'atlas-pagination';
import { Sortable, TableColumnAlignment } from 'atlas-table';
//  

export type EmptyResponse = null;

export interface SortInfo {
  column: string;
  reverse: boolean;
}

export interface FileStatus {
  index: number;
  status: 'Failed' | 'Success' | 'Pending';
  message?: string;
}

export interface FilterInfo {
  [filterKey: string]: string;
}

export interface LoadDataRequest {
  name?: string;
  filter?: FilterInfo;
  pagination?: PaginationInfo;
  sort?: SortInfo;
  [key: string]: any;
  country?: string;
  accountName?: string;
  accountNumber?: number;
}
export interface LoadDataRequestAtlas {
  name?: string;
  filter?: FilterInfo;
  pagination?: PaginationInfo;
  sort?: SortInfo;
  [key: string]: any;
  country?: string;
  accountName?: string;
  accountNumber?: number;
}

export interface TableHeader {
  name: string;
  column?: string;
  textAlign?: string;
  selectable?: boolean;
  disableSort?: boolean;
  sortable?: boolean;
  tooltip?: string;
  icon?: any;
}

export interface ColumnDef {
  fieldKey: string;
  displayLabel?: string;
  align?: TableColumnAlignment;
  sortable?: | Sortable | boolean;
  column?: string;
  name?: string;
  tooltip?: string;
  icon?: any;
  collection?: any;
  size?: any
}
export interface Language {
  label: string;
  value: string;
  currency: string;
}

export interface Country {
  label: string;
  value: string;
  currency: string;
  currencyLabel: string;
}


export interface DatesInterval {
  loading?: boolean;
  min: string;
  max: string;
}

export interface FinancialYearDatesInterval {
  loading?: boolean;
  startDateofFinancialYear: string;
  endDateofFinancilaYear: string;
}

export interface DatesIntervalRequest {
  account?: string;
}

export interface NotificationsItemSettings {
  options: string[];
  email: boolean;
  portal: boolean;
}

export interface NotificationsSettings {
  transactions: NotificationsItemSettings;
  statements: NotificationsItemSettings;
  documents: NotificationsItemSettings;
}

export interface Preferences {
  actual: number;
  netChange: number;
  openCloseBalance: number;
  perfReturns: number;
  range: number;
  strategic: number;
  unitBalance: number;
  unitPrice: number;
  unitsHeld: number;
  allocation: number;
  taxDetails?: number;
  financialYearStartMonth: number;
}

export interface Manager {
  _id: string;
  user: string;
  clients: string[];
  profileImageId: string;
}

export interface ConnectionData {
  firstName: string;
  lastName: string;
  phone: number;
  username: string;
  profileImageId: string;
}


export interface StaticData {
  importantNotices?: string;
  terms?: string;
  about?: string;
  phone?: string;
  email?: string;
  website?: string;
  address?: string;
  entityName?: string;
  contactInfo?: string;
  helpText?: string;
  usingPortal?: string;
  helpWithAccount?: string;
  incidentRecipientsEmail?: string;
  financialMarketsUpdate?: string;
  performanceCommentary?: string;
  clientSpecificperformanceCommentary?: String;
  disclaimerMonthlyReport?: string;
}

export interface CountryStaticData {
  country: string;
  countryFullName: string;
  data: StaticData;
}

export interface PageNotes {
  overview: any;
  valuation: any;
  performance: any;
  holdings: string;
  cashflow: string;
  taxDetails: string;
  transactions: string;
  statements: string;
  reports: any;
  esg: any;
}

export interface LoadRequest {
  [key: string]: string;
}

export const CommonConstants = {
  clientName: 'Client Name',
  fileNotMatchPattern: 'Filename does not match required pattern.',
  displayDateFormatInAU: 'DD MMMM YYYY',
  simpleDateFormatWithDashInAU: 'DD-MM-YYYY',
  simpleDateFormatInAU: 'DD/MM/YYYY',
  DBDateFormat: 'YYYY-MM-DD',
  semanticFontFamilyPlain: 'var(--semanticTypography-font-family-plain)',
  chartFontSizeLarge: '14px',
  chartFontSizeMedium: '11px',
  chartFontSizeSmall: '10px',
  chartFontWeightBold: 'bold',
  chartFontWeightNumeric: '600',
  successToastMSG: 'Changes have been applied',
  totalPortfolio: 'Total Portfolio',
  selectPhoto: 'Please select a photo to upload.',
  profileImageType: 'Please upload photos in *.jpeg, *.jpg, *.png format.',
  profileImageSize: 'Please upload photos max size of 1 mb.',
  noImageAvailable: 'No image available to remove.',
  noDOBAvailable: `No 'Date of Birth' available to remove.`,
  esgOffMessage: `This page will not be displayed to the users of the selected Client as the
  Sustainable Investment option is switched off for this Client.`,
  esgOnMessage: `This page will be displayed to the users of the selected Client as the
  Sustainable Investment option is switched on for this Client.`,
  taxDetailsOffMessage: `This page is not displayed to the users of the selected Client.`,
  taxDetailsOnMessage: `This page is displayed to the users of the selected Client.`,
  productDocumentOnMessage: `This tab is enabled for the selected Client`,
  productDocumentOffMessage: `This tab is switched off for the selected Client.`,
  singleSectorFundProductDocAU: `https://www.multimanager.mercer.com.au/fund-facts/single-sector-funds.html`,
  diversifiedFundProductDocAU: `https://www.multimanager.mercer.com.au/fund-facts/diversified-funds.html`,
  mercerNewZealandProductDocNZ: `https://www.multimanager.mercer.co.nz/`,
  pdfMercerLogoWidth: 1724,
  pdfMercerLogoHeight: 485,
  // pdfMmcLogoWidth: 2447,
  // pdfMmcLogoHeight: 269,
  pdfMmcLogoWidth: 1100,
  pdfMmcLogoHeight: 241,
  notes: `Notes`,
  importantNotices: `Important notices`
};
